const REGEX_PATTERNS = {
    email: '^[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$',
    excludeLettersNumbers: '([^a-zA-Z0-9]+)',
    excludeLettersNumbersUnderscore: '([^a-zA-Z0-9_]+)',
    singleQuote: "'",
}

export const replaceStringByRegex = (str, regexPattern, replaceValue) => {
    if (typeof str !== 'string') {
        return str;
    }
    return str.replace(new RegExp(regexPattern, 'g'), replaceValue);
}

export const sanitizeLettersNumbers = (str) =>
    replaceStringByRegex(str, REGEX_PATTERNS.excludeLettersNumbers, '');

export const sanitizeLettersNumbersUnderscore = (str) =>
    replaceStringByRegex(str, REGEX_PATTERNS.excludeLettersNumbersUnderscore, '');

export const isEmailValid = (email) => new RegExp(REGEX_PATTERNS.email).test(email);
